// ./components/Inventory/AddMainCategory/AddMainCategory.js
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Box, Modal, Container, TextField, Paper, Typography } from "@mui/material";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddMainCategory = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { encodedFormId } = location.state || {}; // Get encodedFormId from navigation state
  const [category, setCategory] = useState({
    mainCategoryName: "",
    description: "",
  });

  const handleReset = () => {
    setCategory({
      mainCategoryName: "",
      description: "",
    });
  };


  const handleChange = (e) => {
    setCategory({ ...category, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/inventory/Categories`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token"),
        },
        body: JSON.stringify({
          mainCategoryName: category.mainCategoryName,
          description: category.description,
        }),
      });

      if (response.ok) {
        setShowSuccessModal(true);
      } else {
        const errorData = await response.json();
        console.error("Failed to add category:", errorData);
        // alert("Failed to add category");
        setSnackbarMessage('Failed to add category');
        setOpenSnackbar(true);
        setSnackbarSeverity("error")

      }
    } catch (error) {
      console.error("Error adding category:", error);
      // alert("An error occurred while adding the category");
      setSnackbarMessage('An error occurred while adding the category');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: '#0B1F40', // dark navy blue
          padding: '12px 24px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          maxWidth: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Add Category
        </Typography> </Box>

      <Paper
        elevation={3}
        style={{ padding: 24, maxWidth: '100%', marginx: "auto", marginTop: 6 }}
      >

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Main Category Name"
            name="mainCategoryName"
            value={category.mainCategoryName}
            onChange={handleChange}
            margin="normal"
            required
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Description"
            name="description"
            value={category.description}
            onChange={handleChange}
            margin="normal"
            multiline
            rows={4}
            variant="outlined"
          />
          <div style={{ marginTop: 16 }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{
                marginRight: 8, width: "80px",
                height: "50px",
                padding: "10px 0",
                fontWeight: 'bold'
              }}
            >
              SAVE
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleReset}
              style={{
                width: "80px",
                height: "50px",
                padding: "10px 0",
                fontWeight: 'bold'
              }}
            >
              RESET
            </Button>
          </div>
        </form>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Category Added ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              The Category has been added successfully.
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

    </Container>
  );
};

export default AddMainCategory;
